import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy-deep py-16 sm:py-24" aria-labelledby="bonuses-title" data-id="element-17" data-mp="pio8klwnr28j">
      <div className="mx-auto max-w-6xl px-6" data-id="element-18" data-mp="au1wqu68osm2">
        <h2 id="bonuses-title" className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-50 sm:text-4xl" data-id="element-19" data-mp="at8ua5ebcp9q">
          3 Action Tools Included — Free With Your Purchase Today.
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-20" data-mp="5wrzwtgiteo7">
          {bonuses.map((bonus, index) => <motion.article key={bonus.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index * 0.08,
          ease: 'easeOut'
        }} className="relative flex h-full flex-col rounded-2xl border border-trust/40 bg-white/[0.04] p-7" data-id="element-21" data-mp="3o36acifkz6hu" data-mpi={index}>
              <span className="absolute -top-3 right-6 rounded-full bg-trust px-3 py-1 text-[11px] font-extrabold uppercase tracking-wider text-white" data-id="element-22" data-mp="3icbv1xinnzoy">
                Free
              </span>

              <img src={bonus.image} alt={`${bonus.label} — ${bonus.title} cover`} className="w-full rounded-xl border border-white/10 bg-white shadow-lg" loading="lazy" data-id="element-23" data-mp="3r5yqtnmv52y5" />

              <p className="mt-6 text-xs font-bold uppercase tracking-[0.16em] text-trust" data-id="element-24" data-mp="2uh951m847q6w">
                {bonus.label}
              </p>
              <h3 className="mt-2 text-lg font-bold leading-snug text-slate-50" data-id="element-25" data-mp="38hjworh918t4">{bonus.title}</h3>
              <p className="mt-2 text-sm font-semibold leading-snug text-slate-400" data-id="element-26" data-mp="33fujp6agul2e">
                {bonus.subtitle}
              </p>
              <p className="mt-3 leading-relaxed text-slate-300" data-id="element-27" data-mp="iqydy0w720v0">{bonus.body}</p>
            </motion.article>)}
        </div>

        <p className="mt-10 text-center text-lg font-semibold text-slate-50" data-id="element-28" data-mp="3chv4tp2jtam4">
          🎁 All 3 action tools are included completely free with your purchase today.
        </p>
      </div>
    </section>;
}